import { ChangeDetectorRef, Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { PopularDestinationCategoryService } from '../popular-destinations-category/popular-destination-category.service';
import { NewsService } from './news.service';
import { LocationOption, AppLocation, LocationTranslation } from './location.model';
import { AppNews } from './news.mode';

interface Option {
  id: number;
  name: string;
}

@Component({
  selector: 'app-news',
  standalone: false,
  templateUrl: './news.component.html',
  styleUrl: './news.component.css'
})
export class NewsComponent {

  successMessage = '';
  errorMessage = '';

  languages: any[] = [];

  news: any[] = [];
  filteredNews: any[] = [];

  currentPage = 1;
  pageSize = 5;
  totalRecords = 0;
  totalPageCount = 1;

  activeTab = 'all';
  activeTabPopup = 1;
  searchText = '';
  isFilterVisible = false;
  filterCategoryId: number | null = null;
  filterYear: number | null = null;
  filterPublishDate = '';
  filterNewsPosition = '';
  filterStatus = '';
  filterLocationId: number | null = null;

  isModalOpen = false;

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  newsId: number = 0;
  NewsCategoryId: number = 0;
  PublishDate: string = this.getTodayIsoDate();
  Slug: string = '';
  status: string = '';
  newsPosition: string = '';

  TitleKh: string = '';
  TitleEn: string = '';
  SummaryKh: string = '';
  SummaryEn: string = '';

  ContentKh: string = '';
  ContentEn: string = '';
  image: File | null = null;
  images: File[] = [];
  existingImageUrls: string[] = [];
  pdfFile: File | null = null;
  existingPdfUrl = '';


  categories: any[] = [];
  mergedNewsCategories: any[] = [];
  selectedCategoryId: number | null = null;

  selectedOptions: Option[] = [];
  // RelatedOption: LocationOption[] = [];

  locationOptions: LocationOption[] = [];
  locationIds: number[] = [];

  relatedNewsOptions: LocationOption[] = [];
  relatedNewsIds: number[] = [];

  constructor(
    private newsService: NewsService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadLanguages();
    this.loadNews("");
    this.loadNewsCategories();
    this.getLocationOptions();
    this.getNewsOptions();
  }

  //Location Option
  getLocationOptions() {
    this.newsService.getLocations().subscribe({
      next: (locations: AppLocation[]) => {
        this.locationOptions = locations.map(loc => {
          const kh = loc.translations.find(t => t.languageName === 'Khmer')?.name ?? '';
          const en = loc.translations.find(t => t.languageName === 'English')?.name ?? '';
          return { id: loc.locationId, name: `${kh} / ${en}` };
        });
      },
      error: (err) => console.error(err)
    });
  }

  onLocationChange() {
    const converted = this.locationIds.map(id => ({ id }));
    console.log(converted);
  }

  //Related News Options
  getNewsOptions() {
  this.newsService.getAllNews("").subscribe({
    next: (response: any) => { // response contains status, message, data
      const newsList: AppNews[] = response.data; // <-- use the data array
      this.relatedNewsOptions = newsList.map(news => {
        const kh = news.translations.find(t => t.languageCode === 'kh')?.title ?? '';
        const en = news.translations.find(t => t.languageCode === 'en')?.title ?? '';
        return { id: news.newsId, name: `${kh} / ${en}` };
      });
    },
    error: (err) => console.error(err)
  });
}

  onRelatedNewsChange(){
    const converted = this.relatedNewsIds.map(id => ({ id }));
    console.log(converted);
  }

  loadNewsCategories() {
    this.newsService
      .getAllNewsCategory()
      .subscribe((res: any) => {

        // Raw data
        this.categories = res.data;

        // Merge KH + EN
        this.mergeNewsCategories();

      });
  }

  mergeNewsCategories() {
    this.mergedNewsCategories = this.categories.map(c => {
      const result = {
        newsCategoryId: c.newsCategoryId,
        kh: '',
        en: '',
        isEnabled: c.isEnabled
      };

      c.translations.forEach((t: { languageCode: string; categoryName: string; }) => {
        if (t.languageCode === 'kh') result.kh = t.categoryName;
        if (t.languageCode === 'en') result.en = t.categoryName;
      });

      return result;
    });
  }

  loadLanguages() {

    this.languageService.getAll().subscribe((res: any) => {

      this.languages = res.data.sort(
        (a: any, b: any) => a.languageId - b.languageId
      );

      if (this.languages.length > 0) {
        this.setTab(this.languages[0].code);
      }

    });

  }

  loadNews(langCode: string) {
    const searchLangCode = langCode && langCode !== 'all'
      ? langCode
      : (this.activeTab !== 'all' ? this.activeTab : '');

    this.newsService.getNewsSearch({
      categoryId: this.filterCategoryId,
      year: this.filterYear,
      publishDate: this.filterPublishDate,
      newsPosition: this.filterNewsPosition,
      status: this.filterStatus,
      locationId: this.filterLocationId,
      title: this.searchText,
      langCode: searchLangCode,
      page: this.currentPage,
      limit: this.pageSize
    })
      .subscribe((res: any) => {

        const result = res.data;
        const apiData: any[] = result?.data || [];

        this.news = apiData
          .filter(item => item.translations && item.translations.length > 0)
          .flatMap(item =>
            item.translations.map((t: any) => ({
              newsId: item.newsId,
              status: item.status,
              newsPosition: item.newsPosition,
              featuredImage: item.featuredImage,
              publishDate: item.publishDate,
              newsCategoryId: item.newsCategoryId,
              imageUrls: item.imageUrls || [],
              locationsId: item.locationsId,
              relatedNewsId: item.relatedNewsId,

              languageCode: t.languageCode,
              languageId: t.languageId,
              categoryName: t.categoryName,
              title: t.title,
              summary: t.summary,
              content: t.content

            }))
          );

        this.totalRecords = result?.totalRecords ?? this.news.length;
        this.totalPageCount = result?.totalPages ?? Math.ceil(this.totalRecords / this.pageSize);
        this.applyLanguageFilter(this.activeTab || langCode || 'kh');

      });

  }

  setTab(tab: string) {

    this.activeTab = tab;
    this.currentPage = 1;

    this.loadNews(tab);
  }


  filterNews(tab: string) {
    this.currentPage = 1;
    this.loadNews(tab);
  }

  applyLanguageFilter(tab: string) {

    this.filteredNews =
      this.news.filter(news => {
        return tab === 'all' || news.languageCode === tab;
      });

  }

  toggleFilters() {
    this.isFilterVisible = !this.isFilterVisible;
  }

  onFilterChange() {
    this.currentPage = 1;
    this.loadNews(this.activeTab || 'kh');
  }

  resetFilters() {
    this.searchText = '';
    this.filterCategoryId = null;
    this.filterYear = null;
    this.filterPublishDate = '';
    this.filterNewsPosition = '';
    this.filterStatus = '';
    this.filterLocationId = null;
    this.currentPage = 1;
    this.loadNews(this.activeTab || 'kh');
  }


  get pagedNews(): any[] {
    return this.filteredNews;

  }

  totalPages(): number {
    return this.totalPageCount;
  }

  changePage(page: number) {
    this.currentPage = page;
    this.loadNews(this.activeTab || 'kh');
  }


  setTabPopup(tab: number) {
    this.activeTabPopup = tab;
  }


  getLanguageCount(lang: string): number {

    return this.news.filter(
      r => r.languageCode === lang
    ).length;

  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { 
      this.isEnableUpdate = true;
      console.log("Edit button enabled");
    }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }

  viewData(id: number, eventName: string) {

    this.visibleButtonControl(eventName);
    this.newsId = id;

    console.log("Selected News ID:", id);
    console.log("Event Name:", eventName);

    this.newsService.getNewsById(id, "").subscribe({
      next: (res) => {

        if (res.status === "success") {

          let data = res.data;
          this.newsId = data.newsId;
          this.NewsCategoryId = data.newsCategoryId;
          this.Slug = data.slug;
          this.PublishDate = data.publishDate.split('T')[0];
          this.status = data.status;
          this.newsPosition = data.newsPosition;
          this.images = [];
          this.pdfFile = null;
          this.existingPdfUrl = data.pdfUrl || '';
          this.existingImageUrls = data.featuredImages || [
            data.featuredImage,
            ...(data.imageUrls || [])
          ].filter(Boolean);

          
          this.locationIds = this.parseSelectedIds(data.locationsId);
          this.relatedNewsIds = this.parseSelectedIds(data.relatedNewsId);
          console.log("KSKKJSKDJK",this.relatedNewsIds);

          // this.locationIds = data.locationsId.split(',').map((id: string) => +id.trim());
          // this.relatedNewsIds = data.relatedNewsIds.split(',').map((id: string) => +id.trim());

          // console.log("KSKKJSKDJK",this.locationIds);

          data.translations.forEach((item: any) => {
            if (item.languageCode === 'kh') {
              this.TitleKh = item.title;
              this.SummaryKh = item.summary;
              this.ContentKh = item.content;
            } else if (item.languageCode === 'en') {
              this.TitleEn = item.title;
              this.SummaryEn = item.summary;
              this.ContentEn = item.content;
            }
          });

          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });


    console.log("Selected News ID 1:", id);
    console.log("Event Name 1:", eventName);

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  resetForm() {
    this.newsId = 0;
    this.NewsCategoryId = 0;
    this.PublishDate = this.getTodayIsoDate();
    this.Slug = '';
    this.status = '';
    this.newsPosition = '';

    this.TitleKh = '';
    this.TitleEn = '';
    this.SummaryKh = '';
    this.SummaryEn = '';

    this.ContentKh = '';
    this.ContentEn = '';
    this.image = null;
    this.images = [];
    this.existingImageUrls = [];
    this.pdfFile = null;
    this.existingPdfUrl = '';
    this.locationIds = [];
    this.relatedNewsIds = [];

  }

  addNew() {

    this.visibleButtonControl('Add');
    this.resetForm();
    this.openModal();

  }

  getRequest(): any {
    return {
      data: {
        newsCategoryId: this.NewsCategoryId,
        publishDate: this.PublishDate + 'T10:30:00',
        slug: this.Slug,
        status: this.status,
        newsPosition: this.newsPosition,
        locationsId: this.formatSelectedIds(this.locationIds),
        relatedNewsId: this.formatSelectedIds(this.relatedNewsIds),
        translations: [
          { languageId: 1, title: this.TitleKh, summary: this.SummaryKh, content: this.ContentKh },
          { languageId: 2, title: this.TitleEn, summary: this.SummaryEn, content: this.ContentEn }
        ]
      },
      images: this.images,
      pdf: this.pdfFile
    };
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.images = Array.from(event.target.files);
      this.image = null;
    }
  }

  onPdfSelected(event: any) {
    this.pdfFile = event.target.files?.[0] || null;
  }

  private formatSelectedIds(ids: number[] | null | undefined): string {
    const selectedIds = (ids ?? []).filter(id => id > 0);
    return selectedIds.length > 0 ? selectedIds.join(',') : '0';
  }

  private parseSelectedIds(value: string | null | undefined): number[] {
    if (!value || value.trim() === '' || value.trim() === '0') {
      return [];
    }

    return value
      .split(',')
      .map(id => Number(id.trim()))
      .filter(id => Number.isFinite(id) && id > 0);
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadNews(this.activeTab || 'kh');
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    const request = this.getRequest();
    this.clearMsg();

    this.newsService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  update() {

    this.clearMsg();

    const request = this.getRequest();

    this.newsService.update(this.newsId, request).subscribe({

      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete ?")) {
      return;
    }

    this.newsService.delete(this.newsId).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  getSafeContent(content: string | undefined | null): string {
    return content?.replace(/&nbsp;/g, ' ') || '';
  }

  private getTodayIsoDate(): string {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  }

}
